export default __webpack_public_path__ + "static/media/433.4b6abe0a.svg";